/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EsgConsolidationTicketsWithProfileId } from '../../models/esg-consolidation-tickets-with-profile-id';
import { EsgDisclosureCode } from '../../models/esg-disclosure-code';
import { EsgTicketsFieldsFilter } from '../../models/esg-tickets-fields-filter';

export interface ConsolidationTicketByProfileByYearByCodeList$Params {
  profileId: number;
  year: number;
  code: EsgDisclosureCode;
  includeFields?: Array<EsgTicketsFieldsFilter>;
}

export function consolidationTicketByProfileByYearByCodeList(http: HttpClient, rootUrl: string, params: ConsolidationTicketByProfileByYearByCodeList$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<EsgConsolidationTicketsWithProfileId>>> {
  const rb = new RequestBuilder(rootUrl, consolidationTicketByProfileByYearByCodeList.PATH, 'get');
  if (params) {
    rb.path('profileId', params.profileId, {});
    rb.path('year', params.year, {});
    rb.path('code', params.code, {});
    rb.query('includeFields', params.includeFields, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<EsgConsolidationTicketsWithProfileId>>;
    })
  );
}

consolidationTicketByProfileByYearByCodeList.PATH = '/esg/profile/consolidation/{profileId}/{year}/{code}/ticket';
